import { ClipboardList, UserCheck, Rocket, BarChart3 } from 'lucide-react';

const steps = [
  {
    icon: ClipboardList,
    step: '01',
    title: 'Package Selection',
    description: 'Choose the right plan — Starter, Growth, or Premium based on your goals.',
  },
  {
    icon: UserCheck,
    step: '02',
    title: 'Onboarding',
    description: 'We collect your clinic details, specialties, and growth objectives.',
  },
  {
    icon: Rocket,
    step: '03',
    title: 'Execution',
    description: 'Our team handles all setup, promotion, and financial management.',
  },
  {
    icon: BarChart3,
    step: '04',
    title: 'Performance Tracking',
    description: 'Monthly reports with transparent updates and actionable growth ideas.',
  },
];

const HowItWorks = () => (
  <section className="bg-[#F9F7F2] py-20 lg:py-28" data-testid="how-it-works-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-14">
        <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#8C6330] mb-4">Our Process</p>
        <h2 className="font-heading text-3xl sm:text-4xl tracking-tight leading-tight text-[#11181C]">
          How Our System Works
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {steps.map((s, i) => (
          <div key={s.title} className="relative text-center group" data-testid={`step-${i}`}>
            <div className="w-16 h-16 rounded-2xl bg-[#D4E4DA] flex items-center justify-center mx-auto mb-5 group-hover:bg-[#1B3F33] transition-colors duration-300">
              <s.icon size={28} className="text-[#1B3F33] group-hover:text-white transition-colors duration-300" />
            </div>
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#8C6330] mb-2">{s.step}</p>
            <h3 className="font-heading text-lg font-medium text-[#11181C] mb-2">{s.title}</h3>
            <p className="text-sm text-[#4A5568] leading-relaxed">{s.description}</p>
            {i < steps.length - 1 && (
              <div className="hidden lg:block absolute top-8 left-[calc(50%+40px)] w-[calc(100%-80px)] h-px bg-[#D6CEBF]" />
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
